import { Button, ButtonProps, useMultiStyleConfig } from '@chakra-ui/react'

type Props = ButtonProps

export const SnackbarButton = (props: Props) => {
  const styles = useMultiStyleConfig('Snackbar')
  return <Button sx={styles.button} size="sm" variant="secondary" {...props} />
}
